import validate from "C:/repositories/optilink-parent/management-tool-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "is-authenticated": () => import("C:/repositories/optilink-parent/management-tool-frontend/middleware/isAuthenticated.ts")
}